import GlobalStorageService from '../../services/GlobalStorageService';

const _serialize = value => {
  return JSON.stringify(value);
};

const _deSerialize = value => {
  try {
    return JSON.parse(value);
  } catch (e) {
    console.error('Error in Parsing information in Object Store');
    return {};
  }
};
const _localStorage = localStorage || GlobalStorageService;
export default {
  setItem(key, value) {
    return _localStorage.setItem(key, _serialize(value));
  },

  getItem(key) {
    return _deSerialize(_localStorage.getItem(key) || '{}');
  },
};
